import { createFileRoute } from '@tanstack/react-router'

import { WallDisplayPage } from '@/components/pages/Dashboard/Wall/WallDisplayPage'

export const Route = createFileRoute('/e/$eventId/_display/wall')({
  component: WallDisplayPage,
  staticData: {
    authRequired: false,
  },
})
